export default __webpack_public_path__ + "static/media/inferno.706c7f8c.jpg";